import isV5ChartDef from './isV5ChartDef';

const isMetricList = (
  def?: ExtendedVisualisationDefinition,
): def is VisualisationDefinitions.GroupVsRemainder => {
  if (isV5ChartDef(def)) {
    return false;
  }

  if (!def) {
    return false;
  }

  return def.type === 'GroupVsRemainder';
};

export default isMetricList;
